<template>
  <div class="mw-upload">
    <div class="mw-toolbar" v-if="buttons.length>0" ref="buttonsContainer">
      <el-button size="small" type="primary" :key="button.id" :id="button.id" v-for="button in buttons">
        <i :class="button.class"></i>{{button.name}}
      </el-button>
    </div>
    <div class="mw-toolbar__body" ref="iframeContainer" style="background-color: transparent">
    </div>
  </div>
</template>
<script>

  export default {
    name: "mw-ntko-attachment",
    data() {
      let me = this;
      return {
        $frame: undefined,
        path: $WR.DOC_CTRL_URL_BASE,
        buttons: me.defButtons
      };
    },
    props: {
      params: {type: Object},
      defButtons: {
        default: function () {
          return [];
        },
        type: Array
      },
      propObject: {
        default: function () {
          return {};
        },
        type: Object
      }
    },
    async mounted() {
      let me = this;
      //获取附件注册格式,是否控制附件大小，附件大小控制，附件名长度,用于判断附件上传功能
      me.attachsFormat = "";  //附件注册格式
      me.attchAlowCode = false; //是否判断附件注册格式
      me.attachAlowSize = ""; //附件限制大小；
      me.attachIsAlowSize = false;  //是否限制附件大小
      me.attchNamelength = "";  //附件上传长度；
      me.attachIsAlowLength = false;  //是否限制附件长度
      if (me.propObject.params.editable) {  //编辑状态下获取附件上传各种限制
        me.mwApi.business.getUploadAttachFormatConfig({}).then(res =>{
          if(res.result){
            let  types = res.result.split(',');
            let a = [];
            types.forEach( (t,index) =>{
              a[index] = '.'+t;
            })
            me.attachsFormat = a.join();
            me.attchAlowCode=true;
          }else{
            me.attchAlowCode=false;
          }
        })
        this.mwApi.business.getUploadMaxAttchSizeConfig({}).then(res =>{
          if(res.result){
            me.attachAlowSize=res.result;
            me.attachIsAlowSize=true;
          }else{
            me.attachIsAlowSize=false;
          }
        })
      }
      me.$nextTick(function () {
        var isShowInFormPanel = "0"; //me._isRawStruct(dd);
        var attchlistId = "attchlist_" + $uuid();
        var btnid = "addfile_" + $uuid();
        var myframeId = "myframe_" + $uuid();

        var iframeText = "";
        var iframeHeight = "0px";
        var ocxWidth, ocxHeight;
        if (isShowInFormPanel == "1") {
          ocxWidth = "1";
          ocxHeight = "1";
          iframeText +=
            '<div><i class="fa x-icon-paperclip"></i><a id="' +
            btnid +
            '" href="#" class="normal" ><span>添加附件</span></a>' +
            '<div id="' +
            attchlistId +
            '" style="background: rgb(237, 244, 248); line-height: 19.99px; font-family: Helvetica Neue, Helvetica, Arial, sans-serif; font-size: 14px;"></div>' +
            "</div>";
        } else {
          ocxWidth = "100%";
          ocxHeight = "100%";
          iframeHeight = "100%";
        }
        var frame = $(
          iframeText +
          '<iframe id="' +
          myframeId +
          '" scrolling="false" style="height:' +
          iframeHeight +
          ";width:100%;border:none;" +
          'padding:0;margin:0;left:0;top:0;overflow:hidden;background-color:#fff;display:block; "' +
          ' src="about:blank"></iframe>'
        );

        frame.on("load", function () {
          var iframe = $(frame);
          me.$frame = iframe;
          var win;
          if (isShowInFormPanel == "1") {
            win = iframe[1].contentWindow;
          } else {
            win = iframe[0].contentWindow;
          }
          var doc = win.contentDocument || win.document;
          var NTKOATTACH_OCX_ID = "NTKOATTACH_OCX_" + $uuid();
          var ocxVersion = me.getDict('97eb7306c8e66d5c') || '5,0,1,8';//NTKO配置/附件控件/控件版本
          var locationhref = window.location;
          var portStr = "";
          if (locationhref.port != 80) {
            portStr = ":" + locationhref.port;
          }
          var whref = locationhref.protocol + "//" + locationhref.hostname + portStr //+ loc.pathname;
          var OfficeControlPath = whref + "/assets/ntkooledocall/nfmctlnewclsid.cab"; //nfmctlnewclsid

          doc.body.innerHTML = `<div style="width:100%;height:100%"><object width="${ocxWidth}" height="${ocxHeight}" id="${NTKOATTACH_OCX_ID}"
        classid="clsid:A99B0DE5-282B-472c-A0C7-53E8182CD474"
        codebase=${OfficeControlPath}#version=${ocxVersion}>

        <param NAME="_ExtentX" VALUE="26">
        <param NAME="_ExtentY" VALUE="26">
        <param NAME="BorderStyle" VALUE="1">
        <param NAME="BorderColor" VALUE="-2147483632">
        <param NAME="BackColor" VALUE="-2147483643">
        <param NAME="ForeColor" VALUE="-2147483640">
        <param NAME="ProductCaption" VALUE="WebOffice综合办公系统">
        <param NAME="ProductKey" VALUE="C7A799FF4E69CBF99253367105E6F95F94367EE4">
        <param NAME="MakerCaption" VALUE="北京美络科技有限公司">
        <param NAME="MakerKey" VALUE="CB4FE3353F5412401BA4A3BDA9CBA50FEA138BBC">
        <param NAME="IsUseUTF8URL" VALUE="1">
        <param NAME="IsUseControlAgent" VALUE="0">
        <param NAME="IsUseUTF8Data" VALUE="1">
        <param NAME="IsGenDiffFileFieldName" VALUE="0">
        <param NAME="IsDirectConnect" VALUE="0">
        <param NAME="MaxUploadSize" VALUE="0">
        <param NAME="Statusbar" VALUE="1">
        <param NAME="NetworkBufferSize" VALUE="0">
        <param NAME="DelFileField" VALUE="delIds">
        <param NAME="IsPermitAddDelFiles" VALUE="1">
        <param NAME="ViewType" VALUE="0">
        <param NAME="Toolbar" VALUE="1">
        <param NAME="IsConfirmSaveModified" VALUE="0">
        <param NAME="DefaultAddFileTypes" VALUE="*.*">
        <param NAME="IsShowContextMenu" VALUE="0">
        <param NAME="IsReadOnlyMode" VALUE="0">
        <param NAME="IsEnableEditMenuItem" VALUE="1">
        <param NAME="IsEnableOpenMenuItem" VALUE="1"><param NAME="IsEnablePaste" VALUE="1">
        <param NAME="IsConfirmDelFiles" VALUE="0"><param NAME="ReceiveDataTimeOut" VALUE="100000">
        <param NAME="ConnectServerTimeOut" VALUE="180"><param NAME="IsShowFileMouseTip" VALUE="1">
        <param NAME="IsEnableSaveAll" VALUE="1"><param NAME="IsEnableAdd" VALUE="1">
        <param NAME="IsEnableViewDetail" VALUE="1"><param NAME="ScannerPicType" VALUE="1">
        <param NAME="IsAllowSelScannerPicType" VALUE="1"><param NAME="IsCloseScannerUI" VALUE="1">
        <param NAME="IsSelScannerIfOnlyOne" VALUE="1"><param NAME="IsSaveOfficeControlDoc" VALUE="0">
        <param NAME="IsShowColumnHeader" VALUE="1"><param NAME="IsUseAsynSave" VALUE="0">
        <param NAME="IsSaveLastSelScanner" VALUE="0"><param NAME="IsUseFileIDInDelFileField" VALUE="0">
        <param NAME="ServerGroupName" VALUE="服务器文件"><param NAME="LocalGroupName" VALUE="本地文件">
        <param NAME="IsForceNoSaveModifiedDlg" VALUE="0"><param NAME="IsShowRename" VALUE="0">
        <param NAME="IsShowMoveUpDown" VALUE="0"><param NAME="IsSupportScannerCombinePDF" VALUE="0">
        <param NAME="IsAutoUseFirstScanner" VALUE="0"><param name="_ExtentX" value="26">
        <param name="_ExtentY" value="26"><param name="BorderStyle" value="1">
        <param name="BorderColor" value="-2147483632"><param name="BackColor" value="-2147483643">
        <param name="ForeColor" value="-2147483640"><param name="IsUseUTF8URL" value="1">
        <param name="IsUseUTF8Data" value="1"><param name="IsUseControlAgent" value="0">
        <param name="IsDirectConnect" value="0"><param name="MaxUploadSize" value="0"><param name="Statusbar" value="1">
        <param name="NetworkBufferSize" value="0"><param name="DelFileField" value="delIds">
        <param name="IsPermitAddDelFiles" value="1"><param name="ViewType" value="0"><param name="Toolbar" value="0">
        <param name="IsConfirmSaveModified" value="0"><param name="IsShowContextMenu" value="0">
        <param name="IsReadOnlyMode" value="0"><param name="IsEnableEditMenuItem" value="1">
        <param name="IsEnableOpenMenuItem" value="1"><param name="IsConfirmDelFiles" value="0">
        <param name="ReceiveDataTimeOut" value="100000"><param name="ConnectServerTimeOut" value="180">
        <param name="IsShowFileMouseTip" value="1"><param name="IsEnableSaveAll" value="1">
        <param name="IsEnableAdd" value="1"><param name="IsEnableViewDetail" value="1">
        <param name="ScannerPicType" value="1"><param name="IsAllowSelScannerPicType" value="1">
        <param name="IsCloseScannerUI" value="1"><param name="IsSelScannerIfOnlyOne" value="1">
        <param name="IsSaveOfficeControlDoc" value="0"><param name="IsShowColumnHeader" value="1">
        <param name="IsUseAsynSave" value="0"><param name="CancelSheetDoubleClick" value="0">
        <param name="IsSaveLastSelScanner" value="0"><param name="IsUseFileIDInDelFileField" value="0">
        <param name="DefaultAddFileTypes" value="*.*"><param name="ServerGroupName" value="服务器文件">
        <param name="LocalGroupName" value="本地文件"><param name="MakerCaption" value="北京美络科技有限公司">
        <param name="MakerKey" value="CB4FE3353F5412401BA4A3BDA9CBA50FEA138BBC">
        <param name="ProductCaption" value="WebOffice综合办公系统">
        <param name="ProductKey" value="C7A799FF4E69CBF99253367105E6F95F94367EE4">
         <param name="wmode" value="opaque">
        <embed  wmode="opaque"></embed>
        <span style="color: red;">不能装载文档控件，请在浏览器的选项中检查浏览器的安全设置。</span></object></div>

        `;

          var cfg = me.propObject;
          if (cfg && cfg.params) {
            cfg.params.NTKOATTACH_OCX_ID = NTKOATTACH_OCX_ID;
            cfg.params.attchlistId = attchlistId;
          } else {
            cfg = {
              params: {
                isShowInFormPanel: isShowInFormPanel,
                NTKOATTACH_OCX_ID: NTKOATTACH_OCX_ID,
                attchlistId: attchlistId
              }
            };
          }
          cfg.params.editmode = me.propObject.params.editable ? "1" : "0";  //是否是编辑模式
          //cfg.ntkoocx=win[NTKOATTACH_OCX_ID];
          var AfterSaveToURL = "AttachManager.afterSaveToURL(retData, errCode);";
          var script = "AttachManager.onRender();";
          var AfterFileDeleted = "AttachManager.afterDeletedToURL(AttachFile)";
          var BeforeFileAdded = "AttachManager.beforeFileAdded(isServerFile, filePathOrURL, fileName, fileSize);";
          var OnLocalFileAdded = "AttachManager.onLocalFileAdded(path,name ,AttachFile);";
          var BeforeFileCommand = "AttachManager.beforeFileCommand(cmdType,IsServerFile,FilePathOrURL ,AttachFile)";
          var BeforeFileOpened = "AttachManager.beforeFileOpened(cmdType,AttachFile)";
          var OnSelectChange = "AttachManager.onSelectChange(selectCount);";
          var OnFileSelecteded = "AttachManager.onFileSelecteded(attachFile);";

          me.AttachManager = win.AttachManager = me.AttachManager(doc, $, cfg, me);
          me.AttachManager.addScript(AfterSaveToURL, {
            language: "JavaScript",
            for: NTKOATTACH_OCX_ID,
            event: "AfterSaveToURL(retData, errCode)"
          }, doc);
          me.AttachManager.addScript(AfterFileDeleted, {
            language: "JavaScript",
            for: NTKOATTACH_OCX_ID,
            event: "AfterFileDeleted(AttachFile)"
          }, doc);
          me.AttachManager.addScript(BeforeFileAdded, {
            language: "JavaScript",
            for: NTKOATTACH_OCX_ID,
            event: "BeforeFileAdded(isServerFile, filePathOrURL, fileName, fileSize)"
          }, doc);
          me.AttachManager.addScript(OnLocalFileAdded, {
            language: "JScript",
            for: NTKOATTACH_OCX_ID,
            event: "OnLocalFileAdded(path,name ,AttachFile)"
          }, doc);
          me.AttachManager.addScript(BeforeFileCommand, {
            language: "JScript",
            for: NTKOATTACH_OCX_ID,
            event: "BeforeFileCommand(cmdType,IsServerFile,FilePathOrURL ,AttachFile)"
          }, doc);
          me.AttachManager.addScript(BeforeFileOpened, {
            language: "JavaScript",
            for: NTKOATTACH_OCX_ID,
            event: "BeforeFileOpened(cmdType,AttachFile)"
          }, doc);
          me.AttachManager.addScript(OnSelectChange, {
            language: "JavaScript",
            for: NTKOATTACH_OCX_ID,
            event: "OnSelectChange(selectCount)"
          }, doc);
          me.AttachManager.addScript(OnFileSelecteded, {
            language: "JavaScript",
            for: NTKOATTACH_OCX_ID,
            event: "OnFileSelecteded(attachFile)"
          }, doc);
          me.AttachManager.addScript(script, {language: "javascript"}, doc);

          $("#add").click(function () {
            me.AttachManager.doAddAttach();
          });
          $("#scanner").click(function () {
            me.AttachManager.doScanner();
          });
          $("#deleteAttach").click(function () {
            me.AttachManager.doDeleteAttach();
          });
          $("#down").click(function () {
            me.AttachManager.doDownOne();
          });
          $("#downall").click(function () {
            me.AttachManager.doDownAll();
          });
          $("#print").click(function () {
            me.AttachManager.doPrint();
          });
          $("#listview").click(function () {
            me.AttachManager.doListView();
          });
          $("#iconview").click(function () {
            me.AttachManager.doIconView();
          });
          $("#doMoveSelectFileUp").click(function () {
            me.AttachManager.doMoveSelectFileUp();
          });
          $("#doMoveSelectFileDown").click(function () {
            me.AttachManager.doMoveSelectFileDown();
          });
          $("#rename").click(function () {
            me.AttachManager.doFileReName();
          });

        });
        $(".mw-toolbar__body", this.$el).append(frame);
      }, 10);
    },
    methods: {
      getDict(dict) {
        this.mwApi.data.getDict(dict).then(function (data) {
          return data;
        });
      },
      getDictByCode(dictcode) {
        //var dictCode=me.getDictByCode("附件格式注册");
        return this.mwApi.data.getDictByCode(dictcode).then(v => v
        ).catch(err => console.log(err));
        //this.mwApi.data.getDictByCode(dictcode).then(function (v) {
        //  return v;
        //});
      },
      listAttachment(data) {
        var me = this;
        //获取附件列表
        let params = {};
        if (data && data.type) {
          params.type = data.type;
        } else {
          params.type = this.propObject.params.efileType;
        }
        params.businessId = data.businessId;
        params.formId = data.formId;
        params.tempBusinessId = data.tempBusinessId;
        return this.mwApi.business.listAttachment(params);
      },
      deleteAttachment(ids) {
        //删除选中的附件
        let params = {};
        // params.attachIds= ids;
        params.businessId = this.propObject.params.businessId;
        params.formId = this.propObject.params.formId;
        params.tempBusinessId = this.propObject.params.tempBusinessId;
        return this.mwApi.business.deleteAttachment(Object.assign({attachIds: ids}, params));
      },
      downLoadAttach(data) {
        let params = {}
        params.id = data.id;
        params.type = this.propObject.params.efileType;
        params.businessId = this.propObject.params.businessId;
        params.formId = this.propObject.params.formId;
        params.tempBusinessId = this.propObject.params.tempBusinessId;
        return this.mwApi.business.downloadAttachment(params, false);
      },
      uploadAttachment(data) {
        let params = {};
        params.type = this.propObject.params.efileType;
        params.businessId = this.propObject.params.businessId;
        params.formId = this.propObject.params.formId;
        params.tempBusinessId = this.propObject.params.tempBusinessId;
      },
      tableDataLoaded(data) {
        // console.log("tableDataLoaded");
        // console.log(data)
        this.$emit('dataLoaded', data);
      },
      AttachManager: function (doc, $, cfg, fme,) {     //fme:当前的vue对象
        return {
          addScript(code, scriptTagAttrs, doc) {
            var head =
              doc.head ||
              doc.getElementsByTagName("head")[0] ||
              doc.documentElement;

            var node = doc.createElement("script");
            node.charset = "UTF-8";
            if (scriptTagAttrs) {
              for (var p in scriptTagAttrs) {
                if (scriptTagAttrs.hasOwnProperty(p)) {
                  node.setAttribute(p, scriptTagAttrs[p]);
                }
              }
            }
            node.innerText = code;
            head.appendChild(node);
          },
          onRender: function () {
            var me = this;
            me.selectFileIds = [];
            me.deleteFileIds = [];
            me.selectFileIndexs = [];
            me.attchList = [];
            me.delCounts = 0;
            PF.applyIf(me, cfg);
            me.ntkoocx = cfg.ntkoocx || doc.getElementById(cfg.params.NTKOATTACH_OCX_ID);
            me.isShowInFormPanel = cfg.params.isShowInFormPanel;
            me.formView = {};
            if (cfg && cfg.params) {
              me.efileType = cfg.params.efileType || "JOA_FJ";
            }
            try {
              if (me.isShowInFormPanel == "1") {
                me.initAttachData(me, true);
              } else {
                me.initAttachData(me);
              }
            } catch (e) {
              alert("初始化附件列表失败!");
            }
          },
          initAttachData: function (me, isReload) {
            if (!me.localInitData) {
              if (me.attchList.length > 0 && !isReload) {
                me.loadAttachData(me.attchList, me);
                fme.tableDataLoaded(me.attchList);
                // fireEvent("afterLoadAttachData", me.ntkoocx, me.attchList);
              } else {
                try {
                  let params = {};
                  params.type = me.params.efileType;
                  params.businessId = me.params.businessId;
                  params.formId = me.params.formId;
                  params.tempBusinessId = me.params.tempBusinessId;
                  fme.listAttachment(params).then(r => {
                    if (r && r.result) {
                      var returnListArr = r.result;
                      me.attchList = returnListArr;
                      me.loadAttachData(returnListArr, me);
                      fme.tableDataLoaded(me.attchList);
                    }
                  });
                } catch (error) {
                  console.log(error);
                  alert("获取附件信息列表失败.");
                }
              }
            }
          },
          loadAttachData: function (attachArr, me) {
            //在控件中拼出所有的附件列表
            //var me = this;
            var loc = window.location;
            var portStr = "";
            if (loc.port != 80) {
              portStr = ":" + loc.port;
            }
            let windowHref = loc.protocol + "//" + loc.hostname + portStr //+ loc.pathname;
            for (var i = 0; i < attachArr.length; i++) {
              var fileId = attachArr[i].id;


              //过滤掉正文
              var efileType = attachArr[i].type;
              // 暂时注释
              /*
              if (
                efileType !== undefined && efileType !== "undefined" && efileType !== "") {
                if ((me.params.efileType || "JOA_FJ").indexOf("JOA_ZW") == -1 &&
                  (efileType == "JOA_ZW" || me.efileType.indexOf(efileType) == -1)
                )
                  continue;
              }
              */
              var efileUrl = windowHref + fme.mwUrl('/api/business/downloadAttachment?')
              var parameters = "";
              var arr = [];
              arr.push('businessId=' + me.params.businessId);
              arr.push('tempBusinessId=' + me.params.tempBusinessId);
              arr.push('formId=' + me.params.formId);
              arr.push('id=' + attachArr[i].id);
              parameters = arr.join("&");
              efileUrl = efileUrl + parameters;
              var attachFile = me.ntkoocx.addServerFile(efileUrl, attachArr[i].name, attachArr[i].size, attachArr[i].createTime);
              if (attachFile) {
                var _sn = i + 1;// 因为暂时没有sn //attachArr[i].sn || "";
                var _createTime = attachArr[i].createTime || "";
                var _creatorId = attachArr[i].creatorId || "";
                var _creatorName = attachArr[i].creator || "";
                me.setFileId(attachFile, fileId); //设置附件ID
                me.setFileSn(attachFile, _sn); //设置附件序号
                me.setFileCreateTime(attachFile, _createTime);
                me.setFileCreatorId(attachFile, _creatorId);
                me.setFileCreatorName(attachFile, _creatorName);
              }
            }
            //屏蔽掉一部分按钮
            var btns = "删除,下载,打印,图标,上移,下移,重命名";
            me.changeButtonStatus(btns, false);
            if (me.ntkoocx.FilesCount > 0) {
              me.changeButtonStatus("全部下载", true);
            }

            if (me.isShowInFormPanel == "1") {
              me.showFileQueue(me);
            }
          },
          getTopToolbar: function () {
            return document.getElementsByClassName("el-button--small");
            //return document.getElementsByClassName("toolbar-el-button");
          },
          changeButtonStatus: function (buttons, enable) {
            //设置某些按钮是否有效无效,直接隐藏
            var me = this;
            var toolBar = fme.$refs.buttonsContainer;
            if (!toolBar) {
              return;
            }
            if (toolBar && toolBar.childNodes && toolBar.childNodes.length == 0) {
              return;
            }
            let hideButton;
            if (cfg.params.editmode === "0") { //只读状态下隐藏字段
              hideButton = ["add", "scanner", "deleteAttach", "rename"]; //隐藏按钮
              me.ntkoocx.IsPermitAddDelFiles = 0; //只读状态下取消双击增加删除附件功能
            } else {
              hideButton = [];
            }
            if (!hideButton || (hideButton && hideButton.length == 0)) {
              return;
            }
            for (var i = 0; i < toolBar.childNodes.length; i++) {
              let v = toolBar.childNodes[i];
              if (v && v.id && hideButton.indexOf(v.id) != -1) {
                $("#" + v.id).hide();
                //v.setAttribute("display","none");
              }
            }
          },
          doAddAttach: function () {
            this.ntkoocx = doc.getElementById(cfg.params.NTKOATTACH_OCX_ID);

            // if ((me.formView.$onlyZw && me.efileType == "JOA_ZW") || me.single_selection)//如果只要一份正文
            // {
            // me.ntkoocx.AddLocalFile('', true, false,'');
            // } else {
            // me.ntkoocx.AddLocalFile();
            this.ntkoocx.AddLocalFile();
            // }
          },
          doScanner: function (id) {
            this.ntkoocx.AddFromScanner();
          },
          doDeleteAttach: function () {
            var me = this;
            me.getSelectFiles();

            if (me.selectFileIds.length == 0) {
              alert("请选择要删除的文件");
              return;
            }
            me.ntkoocx.DoCommand(3);
            //删除附件信息的代码
            try {
              fme.deleteAttachment(me.selectFileIds).then(r => {
                me.ntkoocx.Reset();
                me.deleteAttchByIds(me.selectFileIds);
                fme.tableDataLoaded(me.attchList);
                me.initAttachData(me);
              })
            } catch (error) {
              console.log(error);
              alert("删除附件信息失败");
            }
          },
          deleteAttchByIds: function (ids) {
            var me = this;
            var idStr = ids.join(",");
            var newAttchList = [];
            for (var i = 0; i < me.attchList.length; i++) {
              var attch = me.attchList[i];
              if (idStr.indexOf(attch.id) == -1) {
                newAttchList.push(attch);
              }
            }
            me.attchList = newAttchList;
          },
          doDownOne: function () {
            this.getSelectFiles();
            if (this.selectFileIds.length == 0) {
              alert("请选择要下载的文件");
              return;
            }
            this.ntkoocx.DoCommand(4); //下载
          },
          doDownAll: function () {
            this.ntkoocx.DoCommand(5); //全部下载
          },
          shimPromptDialog: function () {
            $("body>div.el-message-box__wrapper").each(function () {
              if ($(this).find(">iframe").length > 0) return;
              //if($(this).find("iframe").length>0)return;
              var el = $(this).find(".el-message-box");
              var offset = el.offset();
              var width = el.outerWidth();
              var height = el.outerHeight();
              $("<iframe src='about:blank' width=" + width + "px height=" + height + "px style='position:absolute;top:" + offset.top + "px;left:" + offset.left + "px;border:none;z-index:-1'></iframe>").css({
                width: width,
                height: height,
                position: "absolute"
              }).insertBefore(el);
            });
          },
          doFileReName: function () {
            //附件重命名
            var me = this;
            //增加一个iframe，使得弹出框不被遮罩
            //$(fme.$refs.iframeContainer).append('<iframe width="100%" height="100%" position="absolute" z-index="0"></iframe>')
            //var iframe=$("<iframe>").appendTo($(fme.$refs.iframeContainer)).css({filter:"chroma",position:"absolute", height:"320px",width:"650px","z-index":0, top:"100px",left:"30px",scrolling:"auto",frameborder:"0",allowTransparency:"true"});
            var attachFiles = me.getSelectFiles();
            var attachFileId = me.selectFileIds[0];
            if (me.selectFileIds.length == 0) {
              alert("请选择要操作的文件");
              return;
            } else if (me.selectFileIds.length > 1) {
              alert("只能选择一份文件");
              return;
            }
            var attachFile = me.attchList[me.selectFileIndexs];
            var fileName = attachFile.name;
            //重命名
            //fme.$frame.css('display','none');
            fme.$prompt('请输入附件名称', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputValue: fileName,
              closeOnClickModal: false,
            }).then(({value}) => {
              if (value == null || value == '') {
                fme.$alert('附件名不能为空！', '提示', {
                  dangerouslyUseHTMLString: true
                });
                return;
              }
              //iframe.remove();
              //fme.$frame.css('display','block');
              let params = {};
              params.name = value;
              params.type = me.params.efileType;
              params.attachId = attachFileId;
              params.businessId = me.params.businessId;
              params.formId = me.params.formId;
              params.tempBusinessId = me.params.tempBusinessId;
              try {
                me.ntkoocx.Reset();
                fme.mwApi.business.updateAttachment(params).then(r => {
                  fme.listAttachment(params).then(r => {
                    if (r && r.result) {
                      var returnListArr = r.result;
                      me.attchList = returnListArr;
                      me.loadAttachData(returnListArr, me);
                      fme.tableDataLoaded(me.attchList);
                      //iframe.remove();
                    }
                  });
                  //fme.$refs.iframeContainer.css('display','none')
                })
              } catch (error) {
                console.log(error);
                alert("重命名失败");
              }
            }).catch(() => {
              //fme.$frame.css('display','block');
              //fme.$message({
              //  type: 'info',
              //  message: '取消重命名'
              //});
            });
            //me.shimPromptDialog();
            fme.$nextTick(() => {
              setTimeout(() => me.shimPromptDialog(), 100);
            });
            //setTimeout(me.shimPromptDialog(),1000);
          },
          doPrint: function () {
            var me = this;
            me.getSelectFiles();
            if (this.selectFileIds.length == 0) {
              alert("请选择要打印的文件");
              return;
            }
            var length = me.selectFileIndexs.length;
            var i = 0;

            function t_print() {
              if (i == length) {
                return;
              }
              me.ntkoocx.SelectFile(me.selectFileIndexs[i], true); //选中附件
              me.ntkoocx.DoCommand(2); //打印附件
              me.ntkoocx.SelectFile(me.selectFileIndexs[i], false);
              i++;
            }

            setInterval(t_print, 1000);
          },
          doListView: function () {
            var me = this;
            me.ntkoocx.ViewType = 2;
            var btns = "图标";
            me.changeButtonStatus(btns, true);
            btns = "列表";
            me.changeButtonStatus(btns, false);
            return false;
          },
          doIconView: function () {
            var me = this;
            me.ntkoocx.ViewType = 0;
            var btns = "列表";
            me.changeButtonStatus(btns, true);
            btns = "图标";
            me.changeButtonStatus(btns, false);
            return false;
          },
          doMoveSelectFileUp: function () {
            //上移
            var me = this;
            var attachFiles = me.getSelectFiles();
            if (me.selectFileIds.length == 0) {
              alert("请选择要操作的文件");
              return;
            } else if (me.selectFileIds.length > 1) {
              alert("只能选择一个文件进行操作.");
              return;
            }
            var attachFile = attachFiles[0];
            var attachFileIndex = me.getFileIndex(attachFile);
            if (attachFileIndex == 0) { //第一个不移动
              alert("已是第一个附件！");
              return;
            }
            var attachFileId = me.selectFileIds[0];
            let params = {};
            params.moveType = "up";
            params.attachId = attachFileId;
            params.businessId = me.params.businessId;
            params.formId = me.params.formId;
            params.tempBusinessId = me.params.tempBusinessId;
            fme.mwApi.business.updateAttachmentSn(params).then(r => {
              if (r && r.result) {
                let data = {};
                data.type = me.efileType || "JOA_FJ";
                data.businessId = me.params.businessId;
                data.formId = me.params.formId;
                data.tempBusinessId = me.params.tempBusinessId;
                fme.listAttachment(params).then(r => {
                  if (r && r.result) {
                    var returnListArr = r.result;
                    me.attchList = returnListArr;
                    me.ntkoocx.Reset();
                    me.loadAttachData(returnListArr, me);
                    fme.tableDataLoaded(me.attchList);
                  }
                });
              }
            })
          },
          doMoveSelectFileDown: function () {
            //上移
            var me = this;
            var attachFiles = me.getSelectFiles();
            if (me.selectFileIds.length == 0) {
              alert("请选择要操作的文件");
              return;
            } else if (me.selectFileIds.length > 1) {
              alert("只能选择一个文件进行操作.");
              return;
            }
            var attachFile = attachFiles[0];
            var attachFileIndex = me.getFileIndex(attachFile);
            var attachFileId = me.getFileId(attachFile);
            var efileOrders = me.getFileOrders(); //id:order

            var tmpObj = {};
            var count = 0;
            for (var id in efileOrders) {
              var order = efileOrders[id];
              tmpObj[order + ""] = id;
              count++;
            }
            ///*
            if (attachFileIndex == count - 1) { //第一个不移动
              alert("已是最后一个附件！");
              return;
            }
            // */
            var attachFileId = me.selectFileIds[0];
            let params = {};
            params.moveType = "down";
            params.attachId = attachFileId;
            params.businessId = me.params.businessId;
            params.formId = me.params.formId;
            params.tempBusinessId = me.params.tempBusinessId;
            fme.mwApi.business.updateAttachmentSn(params).then(r => {
              if (r && r.result) {
                let data = {};
                data.type = me.efileType || "JOA_FJ";
                data.businessId = me.params.businessId;
                data.formId = me.params.formId;
                data.tempBusinessId = me.params.tempBusinessId;
                fme.listAttachment(params).then(r => {
                  if (r && r.result) {
                    var returnListArr = r.result;
                    me.attchList = returnListArr;
                    me.ntkoocx.Reset();
                    me.loadAttachData(returnListArr, me);
                    fme.tableDataLoaded(me.attchList);
                  }
                });
              }
            })

          },
          doReName: function (me) {
            debugger;
          },
          doSaveAttach: function (me) {
            //附件上传保存附件到服务器
            me.ntkoocx.IsConfirmSaveModified = false;
            //me.saveAttachUrl = fme.mwUrl('/api/business/uploadAttachment?')
            let parameters = "";
            let arr = [];
            arr.push('type=' + me.params.efileType);
            arr.push('businessId=' + me.params.businessId);
            arr.push('formId=' + me.params.formId);
            arr.push('tempBusinessId=' + me.params.tempBusinessId);
            parameters = arr.join("&");
            let loc = window.location;
            let portStr = "";
            if (loc.port != 80) {
              portStr = ":" + loc.port;
            }
            let url = loc.protocol + "//" + loc.hostname + portStr //+ loc.pathname;
            me.saveAttachUrl = url + fme.mwUrl("/api/business/uploadAttachment?") + parameters;
            //me.ntkoocx.beginSaveToURL(me.saveAttachUrl, "uploadFile", {}, '', 0);
            if (me.formName && me.formName != "") {
              //me.ntkoocx.beginSaveToURL(me.saveAttachUrl, "uploadFile", parameters, me.formName, 0);
              me.ntkoocx.beginSaveToURL(me.saveAttachUrl, "uploadFile", {}, me.formName, 0);
            } else {
              me.ntkoocx.beginSaveToURL(me.saveAttachUrl, "uploadFile", {}, '', 0);
            }
          },
          afterDeletedToURL: function (AttachFile, me) {
            //在删除文件之后发生
          },
          beforeFileAdded: async function (
            isServerFile,
            filePathOrURL,
            fileName,
            fileSize
          ) {
            var me = this;
            me.formView = {};
            // me.formView.$onlyZw &&
            if (
              me.params.efileType == "JOA_ZW" &&
              me.ntkoocx.FilesCount == 1
            ) {
              alert("正文只允许上传一个!");
              me.ntkoocx.CancelLastCommand = true;
              return;
            }
            if (me.$limitOnlyOne && me.ntkoocx.FilesCount == 1) {
              alert("只允许上传一个!");
              me.ntkoocx.CancelLastCommand = true;
              return;
            }
            var me = this;
            if (isServerFile) return;
            //if (me.fileExt && me.fileExt != "") {
            //判断附件的上传格式是否正确
            if (fme.attchAlowCode) {
              if (fileName) {
                var extIndex = fileName.lastIndexOf(".");
                if (extIndex > 0) {
                  var isAllow = false;
                  var exp = fileName.substring(extIndex).toLowerCase();
                  var format = fme.attachsFormat;
                  if (format == null || format == undefined || format == "") {
                    isAllow = true;
                  } else if (format.indexOf(exp) == -1) {
                    isAllow = false;
                  } else {
                    isAllow = true;
                  }
                  if (!isAllow) {
                    alert("请上传格式为" + format + "的文件");
                    me.ntkoocx.CancelLastCommand = true;
                    return;
                  }
                }
              }
            }

            /*
            if (fileName) {
              //for file has not ext

              var extIndex = fileName.lastIndexOf(".");

              if (extIndex > 0) {
                var isAllow = false;
                var exp = fileName.substring(extIndex).toLowerCase();
                debugger;
                if (me.fileExt.indexOf(";") > 0) {
                  var farry = me.fileExt.split(";");
                  for (var i = 0; i < farry.length; i++) {
                    if (farry[i].toLowerCase().indexOf(exp) > 0) {
                      isAllow = true;
                      break;
                    }
                  }
                } else {
                  isAllow = true;
                }

                if (!isAllow) {
                  alert("不允许上传" + exp + "类型的文件");
                  me.ntkoocx.CancelLastCommand = true;
                  return;
                }
                //var format = ".doc,.docx,.pdf,.jpeg,.png";
                var format = attachsFormat;
                if (
                  me.efileType == "JOA_ZW" &&
                  isAllow &&
                  format.indexOf(exp) == -1
                ) {
                  alert("请上传格式为" + format + "的文件");
                  me.ntkoocx.CancelLastCommand = true;
                  return;
                }

                if(isAllow && format && format.indexOf(exp) == -1){
                  alert("请上传格式为" + format + "的文件");
                  me.ntkoocx.CancelLastCommand = true;
                  return;
                }
              }
            }
            */
            attchNamelength = fme.attchNamelength ? parseFloat(fme.attchNamelength) : 520;
            if (fme.attachIsAlowLength && filePathOrURL.length > attchNamelength) {
              alert("上传附件路径字符过长。");
              me.ntkoocx.CancelLastCommand = true;
            }
            var i;
            for (i = 0; i < me.ntkoocx.FilesCount; i++) {
              var AttachFile = me.ntkoocx.GetFile(i);
              if (
                fileName == AttachFile.FileName &&
                filePathOrURL == AttachFile.FilePath
              ) {
                alert("[" + fileName + "] 已存在.");
                me.ntkoocx.CancelLastCommand = true;
                return;
              } else if (fileName == AttachFile.FileName) {
                if (confirm("[" + fileName + "] 已存在,是否继续添加?") == false) {
                  me.ntkoocx.CancelLastCommand = true;
                  return;
                }
              }
            }

            //限制允许上传附件的大小
            if (fme.attachIsAlowSize) {
              var limitFileSize = fme.attachAlowSize ? fme.attachAlowSize : me.limitFileSize;
              var size = (fileSize / 1024 / 1024).toFixed(2);
              if (
                limitFileSize &&
                parseFloat(size) > parseFloat(limitFileSize)
              ) {
                alert("不允许添加超过" + limitFileSize + "M字节的附件！");
                me.ntkoocx.CancelLastCommand = true;
              }
            }
          },
          onLocalFileAdded: function (path, name, attachFile) {
            var me = this;
            attachFile.IsAllowOpenFolder = true;
            if (me.isShowInFormPanel === "1") {
              this.showFileQueue(me);
            } else {
              this.doSaveAttach(me);
            }
          },
          onFileSelecteded: function (attachFile, me) {
            var me = this;
            var btns = "删除,下载,打印,重命名";
            me.changeButtonStatus(btns, true); //设置按钮有效
            if (me.getFileCount() > 1) {
              btns = "上移,下移";
              me.changeButtonStatus(btns, true); //设置按钮有效
            }
          },
          onSelectChange: function (selectCount, me) {
            var me = this;
            var flag = selectCount > 1;
            var btns = "删除,下载,打印,重命名";
            me.changeButtonStatus(btns, flag);
            flag = selectCount > 1 && me.getFileCount() > 1;
            btns = "上移,下移";
            me.changeButtonStatus(btns, flag);
          },
          beforeFileCommand: function (
            cmdType,
            isServerFile,
            filePathOrURL,
            attachFile
          ) {
            var me = this;
            var commandstr = "";
            switch (cmdType) {
              case 0:
                commandstr = "ntkoCmdEdit";
                break;
              case 1:
                commandstr = "ntkoCmdOpen";
                break;
              case 2:
                commandstr = "ntkoCmdPrint";
                break;
              case 3:
                commandstr = "ntkoCmdDelete";
                if (me.isShowInFormPanel != "1" && me.delOprFrom == "keyboard") {
                  //如果是在表单里面显示的，就不处理
                  me.ntkoocx.CancelLastCommand = true; //取消del键删除操作
                }
                break;
              case 4:
                commandstr = "ntkoCmdSave";
                break;
              case 5:
                commandstr = "ntkoCmdSaveAll";
                break;
              case 6:
                commandstr = "ntkoCmdRename";
                break;
              case 7:
                commandstr = "ntkoCmdOpenFolder";
                break;
              case 8:
                commandstr = "ntkoCmdViewProp";
                break;
            }
          },
          beforeFileOpened: function (cmdType, attachFile) {
            //文件被打开之前触发。这时如果是服务器文件，已经下载完成。在刚刚打开之前触发。该事件可以用于禁止某些文件的打开。
            //在这个事件中设定CancelLastCommand = true;可以阻止打开文件。
            var me = this;
            var commandstr = "";
            switch (cmdType) {
              case 0:
                commandstr = "ntkoCmdEdit";
                break;
              case 1:
                commandstr = "ntkoCmdOpen";
                let me = this;
                if (!attachFile) return;
                //这里判读是否可以编辑,如果可以，并且是 word文件，就打开在线编辑
                var fileName = me.getFileName(attachFile);
                var fileUrl = me.getFileURL(attachFile);
                var fileId = me.getFileId(attachFile);
                if (fileUrl && (fileName.indexOf(".doc") != -1 || fileName.indexOf(".docx") != -1 || fileName.indexOf(".xls") != -1 || fileName.indexOf(".pptx") != -1) || fileName.indexOf(".ppt") != -1) {
                  me.params.efileType = me.efileType;
                  me.params.fileUrl = fileUrl;
                  me.params.fileName = fileName;
                  me.params.fileId = fileId;
                  PF.show('OnLineEfileEdit', me.params, null);

                  //   //用在线编辑器打开
                  // var fileLinkId = me.getFileId(attachFile);
                  // var pk_id = me.params.pk_id;
                  // var docEditMode = "0";
                  // if (me.canOnlineEdit) {
                  //   docEditMode = "1";
                  // }
                  // var formComponentId = '';
                  // var isFlowForm = false
                  // if (me.config.formView.isFlowForm) {
                  //   isFlowForm = me.config.formView.isFlowForm();
                  // }
                  // var flowModuleId = '';
                  // if (isFlowForm) {
                  //   formComponentId = me.config.formView.formComponentId;
                  //   flowModuleId = me.params.flowModuleId;
                  // }
                  // var flag;
                  // var isSaveRevs;
                  // fnDataItemResolver("系统设置/附件管理/附件是否可编辑",function(r){
                  //   if(r) flag = r;
                  // });
                  // fnDataItemResolver("系统设置/附件管理/附件是否保留痕迹",function(r){
                  //   if(r) isSaveRevs = r;
                  // });

                  // if (isSaveRevs == 'T') {
                  //   isSaveRevs = '0';
                  // } else {
                  //   isSaveRevs = '1';
                  // }
                  // if (flag == 'F') {
                  //   docEditMode = '0'
                  // }

                  // //用来标识是否编辑附件 me.$editFj 是在表单里定义的
                  // if (me.$editFj == false) {
                  //   docEditMode = '0';
                  // }

                  // var obj = {
                  //   filepath: me.getFilePath(attachFile), //此参数表明是附件在线编辑，保存时保存到本地
                  //   fileUrl: fileUrl,
                  //   fileLinkId: fileLinkId,
                  //   pk_id: pk_id,
                  //   trs: false,
                  //   isLoadFormData: false,
                  //   fileSaveAs: true,
                  //   // step: 'edit',
                  //   fileName: fileName,
                  //   editmode: docEditMode,
                  //   efileType: me.efileType,
                  //   showProgressBar: false,
                  //   isShowRevisions: false,
                  //   isTempLinked: 'NO',
                  //   isSaveTrackRevisions: isSaveRevs,
                  //   openMode: 'iframe',// 打开附件内容编辑修改后点击保存退出，只把word文件关闭了，浏览器空白页没关闭
                  //   // fileprint: false,
                  //   from: me.config.from || "",
                  //   afterOpen: function (ntko) {
                  //     if (docEditMode == '1' && !ntko.useExtButton) {
                  //       try {
                  //         ntko.webOfficeocx.AddCustomButtonOnMenu(0, "保存文件");
                  //         ntko.webOfficeocx.AddCustomButtonOnMenu(1, "保存并退出");
                  //       } catch (e) {
                  //       }
                  //     }
                  //     if (isSaveRevs == '0' && (ntko.isWordDocument() || ntko.isWPSDocument())) {
                  //       ntko.webOfficeocx.AddCustomMenu2(0, "修订");
                  //       ntko.webOfficeocx.AddCustomMenuItem2(0, 0, -1, false, "显示修订");
                  //       ntko.webOfficeocx.AddCustomMenuItem2(0, 1, -1, false, "隐藏修订")

                  //     }
                  //   }
                  // };
                  // var config = {
                  //   isShowTbar: "0",
                  //   border: false,
                  //   params: obj
                  // };
                  // if (me.eidtEfileOpenModel == 'exp-win') {
                  //   var url = "${serverPath}/view?$$vid=online-efile-edit-window-container" + "&pk_id=" + pk_id

                  //     +
                  //     "&title=" + fileName;
                  //   var _winId = fileLinkId ? fileLinkId : Math.floor(Math.random() * 10);
                  //   var _nativeWin = me.openOnlineEditWindowUrl(url, _winId, 845, 638);
                  //   window[pk_id + '_getConfig'] = function () {
                  //     return config;
                  //   }

                  // } else {
                  //   var win = new Ext.ml.DialogBox({
                  //     panel: (new miracle.AttachOnlineEditPanel(config)),
                  //     title: '电子文件在线编辑窗口',
                  //     width: "80%",
                  //     height: Ext.getBody().getHeight(),
                  //     noButtons: true,
                  //     modal: true
                  //   });
                  //   win.show();
                  //   win.panel.on("afterDocumentOpened", function () //在firefox打开的时候panel回被遮挡,需要让该panel最大化一下才能显示
                  //   {
                  //     if (!Ext.isIE) win.win.maximize();
                  //   });
                  //   win.win.on("beforeclose", function () {
                  //     return win.panel.fireEvent("beforeclose");
                  //   });
                  // }
                  me.ntkoocx.CancelLastCommand = true; //取消当前的操作
                }
                break;
              case 2:
                commandstr = "ntkoCmdPrint";
                break;
              case 3:
                commandstr = "ntkoCmdDelete";
                break;
              case 4:
                commandstr = "ntkoCmdSave";
                break;
              case 5:
                commandstr = "ntkoCmdSaveAll";
                break;
              case 6:
                commandstr = "ntkoCmdRename";
                break;
              case 7:
                commandstr = "ntkoCmdOpenFolder";
                break;
              case 8:
                commandstr = "ntkoCmdViewProp";
                break;
            }
          },
          afterSaveToURL: function (retData, errCode) {
            var me = this;
            if (errCode == 0) {
              //取得后台返回的错误信息
              // var resp = JSON.stringify(retData);
              //var resp = JSON.parse(retData);
              //if (resp.result.success == false) {
              //  alert(resp.result.msg);
              //} else {
              // me.attchList.push(resp.result);
              // fireEvent("afterSaveToURL", me, resp.result);
              //}
              //delete resp.result.success;
              //delete resp.result.msg;

              if (me.isShowInFormPanel !== "1") {
                //清空附件列表
                me.ntkoocx.Reset();
                //重新加载附件列表数据
                me.attchList = [];
                me.initAttachData(me);
              }
              var btns = "全部下载";
              me.changeButtonStatus(btns, true); //设置按钮有效
              // me.formView.isUploadEfile = true;//判断已经上传了附件
            } else if (errCode == 1) {
              //标识文件存取错误
              alert("文件存取错误");
            } else if (errCode == 2) {
              //标识网络传送错误
              alert("网络传送错误");
            } else if (errCode == 3) {
              //标识内存错误
              alert("内存错误");
            } else if (errCode == 10) {
              //用户取消
              //alert("用户取消");//取消了要把控件里面的本地文件删除
              me.removeLocalFile();
            } else if (errCode == 11) {
              //超时终止,  MaxWaitSeconds
              alert("超时终止");
            } else if (errCode == 100) {
              //标识其他未知错误
              alert("其他未知错误");
            } else if (errCode > 100) {
              //服务器返回的错误状态信息
              alert("服务器返回的错误状态信息");
            }
          },
          showFileQueue: function (me) {
            var tempstr = "";
            for (var i = 0; i < me.ntkoocx.FilesCount; i++) {
              var AttachFile = me.ntkoocx.GetFile(i);
              var FileName = AttachFile.FileName;
              var FileSize = AttachFile.FileSize;

              var createTime = this.getFileCreateTime(AttachFile);
              var creatorName = this.getFileCreatorName(AttachFile);
              var creatorId = this.getFileCreatorId(AttachFile);
              var isShowUserInfo = true; //$("#fjlist").attr("userInfo") || false;
              var isDelLimit = false; //$("#fjlist").attr("delLimit") || false;

              var userInfo = "";
              if (isShowUserInfo == "true" && creatorName && createTime) {
                userInfo += "(" + creatorName + "," + createTime + ")";
              }

              if (FileSize >= 1024 * 1024) {
                FileSize = (FileSize / 1024 / 1024).toFixed(2) + "M";
              } else if (FileSize >= 1024) {
                FileSize = (FileSize / 1024).toFixed(2) + "K";
              } else {
                FileSize = FileSize + "B";
              }
              // var fileList = "<i class='fa x-icon-paperclip'></i>" + FileName + "(" + FileSize + ")" + userInfo + "<a onclick=AttachManager.doAttFile(" + i + ",'open','" + me.id + "',me) href='javascript:void(0)'>打开</a>&nbsp;&nbsp;";
              // fileList += "<a onclick=AttachManager.doAttFile(" + i + ",'down','" + me.id + "',me)  href='javascript:void(0)'>下载</a>&nbsp;&nbsp;";

              // if (me.editmode == "1") {
              //   if (isDelLimit == "true") {
              //     if ($userId == creatorId) {
              //       fileList += "<a onclick=AttachManager.doAttFile(" + i + ",'del','" + me.id + "',me)  href='javascript:void(0)'>删除</a>";
              //     }
              //   } else {
              //     fileList += "<a onclick=AttachManager.doAttFile(" + i + ",'del','" + me.id + "',me)  href='javascript:void(0)'>删除</a>";
              //   }
              // }
              // --------------------------------------------
              var fileList =
                "<i class='fa x-icon-paperclip'></i>" +
                FileName +
                "(" +
                FileSize +
                ")" +
                userInfo +
                "<a  name='open' filecount='" +
                i +
                "' href='javascript:void(0)'>打开</a>&nbsp;&nbsp;";
              fileList +=
                "<a name='down' filecount='" +
                i +
                "'  href='javascript:void(0)'>下载</a>&nbsp;&nbsp;";

              if (me.editmode == "1") {
                if (isDelLimit == "true") {
                  if ($userId == creatorId) {
                    fileList +=
                      "<a name='del' filecount='" +
                      i +
                      "' href='javascript:void(0)'>删除</a>";
                  }
                } else {
                  fileList +=
                    "<a name='del' filecount='" +
                    i +
                    "' href='javascript:void(0)'>删除</a>";
                }
              }
              // ---------------------------------
              if (tempstr === "") {
                tempstr = fileList;
              } else {
                tempstr = tempstr + "<br>" + fileList;
              }
            }

            // doc.getElementById(me.attchlistId).innerHTML = "";
            // doc.getElementById(me.attchlistId).innerHTML = tempstr;
            // document.getElementById(me.myframeId).style.height = 20 + doc.getElementById(me.attchlistId).scrollHeight + "px";

            document.getElementById(me.attchlistId).innerHTML = "";
            document.getElementById(me.attchlistId).innerHTML = tempstr;
            // document.getElementById(me.myframeId).style.height = 20 + document.getElementById(me.attchlistId).scrollHeight + "px";
            var delbtns = document.getElementsByName("del");
            for (var i = 0; i < delbtns.length; i++) {
              delbtns[i].onclick = function () {
                var filecount = this.attributes.filecount.value;
                me.doAttFile(filecount, "del", me.id, me);
              };
            }
            var openbtns = document.getElementsByName("open");
            for (var i = 0; i < openbtns.length; i++) {
              openbtns[i].onclick = function () {
                var filecount = this.attributes.filecount.value;
                me.doAttFile(filecount, "open", me.id, me);
              };
            }
            var downbtns = document.getElementsByName("down");
            for (var i = 0; i < downbtns.length; i++) {
              downbtns[i].onclick = function () {
                var filecount = this.attributes.filecount.value;
                me.doAttFile(filecount, "down", me.id, me);
              };
            }
          },
          showFileQueueInForm: function (me, data) {
            // var efileListObj = me.formView.findElement("#efilelist");
            var efileListObj = document.getElementById("#" + me.attchlistId);
            if (efileListObj.length == 0) return;
            var tempstr = "";
            for (var i = 0; i < data.length; i++) {
              var AttachFile = data[i];
              var FileName = AttachFile.efileName || AttachFile.fileName;
              var FileSize = AttachFile.fileSize;
              var FileURL = me.downAttachUrl;
              if (FileURL.lastIndexOf("?") == -1) {
                FileURL += "?";
              } else {
                FileURL += "&";
              }
              FileURL += "id=" + AttachFile.id;
              if (FileSize >= 1024 * 1024) {
                FileSize = (FileSize / 1024 / 1024).toFixed(2) + "M";
              } else if (FileSize >= 1024) {
                FileSize = (FileSize / 1024).toFixed(2) + "K";
              } else {
                FileSize = FileSize + "B";
              }
              var efileText =
                "<img src='${serverPath}/sysicons/sys_toolbar/attach.gif'>" +
                FileName +
                "(" +
                FileSize +
                ")";
              var fileList =
                i + 1 + ".<a href='" + FileURL + "'>" + efileText + "</a>";
              if (tempstr === "") {
                tempstr = fileList;
              } else {
                tempstr = tempstr + "<br>" + fileList;
              }
            }
            // efileListObj.html("");
            efileListObj.html(tempstr);
          },
          doAttFile: function (fileCont, type, id, me) {
            // var me = this;
            if (!me.ntkoocx) {
              alert("NTKO附件管理控件装载失败!");
              return;
            }
            for (var i = 0; i < me.ntkoocx.FilesCount; i++) {
              if (i == fileCont) {
                me.ntkoocx.SelectFile(i, true);
              } else {
                me.ntkoocx.SelectFile(i, false);
              }
            }

            if (type === "down") {
              me.ntkoocx.DoCommand(4);
            } else if (type === "open") {
              me.ntkoocx.DoCommand(1);
            } else if (type === "del") {
              this.getSelectFiles(me);
              me.deleteFileIds[me.delCounts++] = me.selectFileIds[0];
              me.ntkoocx.DoCommand(3);
              this.showFileQueue(me);
            }
          },
          getFileId: function (attachFile) {
            //取得附件ID
            return attachFile.getCustomData(0);
          },
          setFileId: function (attachFile, fileId) {
            //设置附件ID
            attachFile.SetCustomData(0, fileId);
          },
          getFileSn: function (attachFile) {
            //取得附件的序号
            return attachFile.getCustomData(1);
          },
          setFileSn: function (attachFile, sn) {
            //设置附件序号
            attachFile.SetCustomData(1, sn);
          },
          setFileCreateTime: function (attachFile, createTime) {
            //设置附件上传时间
            attachFile.SetCustomData(2, createTime);
          },
          getFileCreateTime: function (attachFile) {
            //取得附件上传时间
            return attachFile.getCustomData(2);
          },
          setFileCreatorId: function (attachFile, creatorId) {
            //设置附件上传者ID
            attachFile.SetCustomData(3, creatorId || "");
          },
          getFileCreatorId: function (attachFile) {
            //取得附件上传者ID
            return attachFile.getCustomData(3);
          },
          setFileCreatorName: function (attachFile, createName) {
            //设置附件上传者名称
            attachFile.SetCustomData(4, createName || "");
          },
          getFileCreatorName: function (attachFile) {
            //取得附件上传者名称
            return attachFile.getCustomData(4);
          },
          getFileName: function (attachFile) {
            //取得附件名称
            return attachFile.FileName;
          },
          getFilePath: function (attachFile) {
            //取得附件路径
            return attachFile.FilePath;
          },
          getFileURL: function (attachFile) {
            //返回本地文件或者已经下载的服务器文件的全路径
            return attachFile.FileURL;
          },
          getFileSize: function (attachFile) {
            //文件大小
            return attachFile.FileSize;
          },
          getFileIndex: function (attachFile) {
            //文件在控件内的位置序号，从0 开始
            return attachFile.SortOrder;
          },
          getSelectedFileCount: function (me) {
            //取得控件里面选中文件的数量
            this.getSelectFiles(me);
            return this.selectFileIds.length;
          },
          getFileCount: function () {
            //取得控件里面的文件数量
            return this.ntkoocx.FilesCount;
          },
          getSelectFiles: function (me) {
            //取得所有选择的附件的id值
            var me = this;
            if (me.selectFileIds.length > 0) {
              me.selectFileIds = [];
            }
            me.selectFileIndexs = [];
            var attachFiles = [];
            for (var i = 0; i < this.getFileCount(); i++) {
              if (this.isFileSelected(i)) {
                var attachFile = this.getAttachFile(i);
                if (this.isServerFile(attachFile)) {
                  me.selectFileIds.push(this.getFileId(attachFile));
                  attachFiles.push(attachFile);
                  me.selectFileIndexs.push(i);
                }
              }
            }
            return attachFiles;
          },
          getFileOrders: function () {
            //取得控件内所有附件的顺序号
            var me = this;
            var orders = {};
            for (var i = 0; i < me.getFileCount(); i++) {
              var attachFile = me.getAttachFile(i);
              if (me.isServerFile(attachFile)) {
                var fileId = me.getFileId(attachFile);
                var fileOrder = me.getFileIndex(attachFile);
                orders[fileId] = fileOrder;
              }
            }
            return orders;
          },
          isFileSelected: function (index) {
            //判断文件是否被选中,index为文件在控件中的序号
            return this.ntkoocx.IsFileSelected(index);
          },
          getAttachFile: function (index) {
            //index为文件在控件中的序号
            return this.ntkoocx.GetFile(index);
          },
          isServerFile: function (attachFile) {
            //是否服务器文件
            return attachFile.IsServerFile;
            // return true;
          }
        };
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/common/components/extend/ntko/ntko-attachment.vue